module.exports = __webpack_public_path__ + "static/media/image-1.5a75e42b.jpg";